import { render, staticRenderFns } from "./CommonUserAvatar.vue?vue&type=template&id=44618ee0"
import script from "./CommonUserAvatar.vue?vue&type=script&lang=js"
export * from "./CommonUserAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports